<template>
    <div class="container-fluid">
        <div class="titlle_div">
            <h5 class="title">Editar Usuario</h5>
        </div>
        <br>
        <emt-form ref="user-form" v-bind:resource="itemresource" v-bind:items="items_form" v-bind:updateData="update"></emt-form>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import router from '@/router'
import generic from '@/generic'
import Config from '@/config'
import EmtForm from '@/components/emt-form-register-user'

export default {
    name: 'emt-form-edit-user',
    data: function () {
        return {
            items_form: [
                {
                    'name': 'username',
                    'label': 'Nombre de usuario',
                    'placeholder': 'Ingrese nombre de usuario',
                    'value': null,
                    'maxlength': '30',
                    'type': 'text',
                    'readonly': 'readonly',
                    'errors': []
                }, {
                    'name': 'first_name',
                    'label': 'Nombres',
                    'value': null,
                    'placeholder': 'Ingrese Nombres',
                    'maxlength': '30',
                    'type': 'text',
                    'errors': []
                }, {
                    'name': 'last_name',
                    'label': 'Apellidos',
                    'value': null,
                    'placeholder': 'Ingrese Apellidos',
                    'maxlength': '30',
                    'type': 'text',
                    'errors': []
                }, {
                    'name': 'email',
                    'label': 'Correo electrónico principal',
                    'value': null,
                    'placeholder': 'Ingrese Correo electrónico principal',
                    'maxlength': '254',
                    'type': 'text',
                    'errors': []
                }, {
                    'name': 'email_alternative',
                    'label': 'Correo electrónico alternativo',
                    'value': null,
                    'placeholder': 'Ingrese correo electrónico alternativo',
                    'maxlength': '200',
                    'type': 'text',
                    'errors': []
                }, {
                    'name': 'group',
                    'label': 'Perfil',
                    'placeholder': 'Seleccione un perfil',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': []
                }, {
                    'name': 'unit',
                    'label': 'Unidad',
                    'placeholder': 'Seleccione una unidad',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': [],
                    'visible': false
                }, {
                    'name': 'company',
                    'label': 'Empresa o filial',
                    'placeholder': 'Seleccione una empresa o filial',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': [],
                    'visible': false
                }, {
                    'name': 'is_active',
                    'label': 'Estado',
                    'value': false,
                    'type': 'checkbox',
                    'errors': []
                }, {
                    'name': 'password',
                    'label': '',
                    'placeholder': 'Ingrese contraseña',
                    'value': null,
                    'maxlength': '30',
                    'type': 'password',
                    'errors': []
                }
            ],
            itemresource: [
                {
                    'resourceUser': '/user/'
                }
            ],
            config: Config,
            update: true,
            group: '',
            unit: '',
            company: ''
        }
    },
    created: function () {
        if (!Cookies.get('token')) {
            router.push('/login')
            return
        }
        generic.setToken()
        this.getGroup()
        this.getUnits()
        this.getCompany()
        this.getData(Config.api + '/user_full_data/?id=')
    },
    methods: {
        getData: function (url) {
            url = url + this.$route.params.id
            let self = this
            self.$http.get(url).then(function (response) {
                self.setValue(response.body.results[0])
            }, function (response) {
            })
        },
        setValue: function (value) {
            for (var form in this.items_form) {
                if (this.items_form[form].name === 'unit' && value['unit_user'] !== null) {
                    this.unit = value['unit_user'].unit
                    document.getElementsByName('unit')[0].value = this.unit
                    if (document.getElementsByName('unit')[0].value !== '') {
                        this.items_form[form].value = value['unit_user'].unit
                        this.items_form[form].visible = true
                    } else {
                        this.items_form[form].value = ''
                    }
                } else if (this.items_form[form].name === 'company' && value['company_user'] !== null) {
                    this.company = value['company_user'].company
                    document.getElementsByName('company')[0].value = this.company
                    if (document.getElementsByName('company')[0].value !== '') {
                        this.items_form[form].value = value['company_user'].company
                        this.items_form[form].visible = true
                    } else {
                        this.items_form[form].value = ''
                    }
                } else {
                    if (this.items_form[form].name === 'group') {
                        this.group = value.groups[0].id
                        document.getElementsByName('group')[0].options.selectedIndex = this.group
                        this.items_form[form].value = this.group
                        continue
                    } else {
                        var valueuser = value
                        var item = this.items_form[form].name
                        this.items_form[form].value = valueuser[item]
                    }
                }
            }
        },
        getUnits: function () {
            var self = this
            self.$http.get(Config.api + '/unit/?nopaginate=1&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.items_form[6].select_options.push({
                        value: response.body[data].id,
                        text: response.body[data].name
                    })
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        },
        getGroup: function () {
            var self = this
            self.$http.get(Config.api + '/group/?nopaginate=1&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.items_form[5].select_options.push({
                        value: response.body[data].id,
                        text: response.body[data].name
                    })
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        },
        getCompany: function () {
            var self = this
            self.$http.get(Config.api + '/company/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.items_form[7].select_options.push({
                        value: response.body[data].id,
                        text: response.body[data].name
                    })
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        }
    },
    mounted: function () {
        document.getElementsByName('password')[0].style.display = 'none'
    },
    components: {
        'emt-form': EmtForm
    }
}
</script>



// WEBPACK FOOTER //
// emt-form-edit-user.vue?720d4944